import { toast } from "react-toastify";
import { FiStar } from "react-icons/fi";
import { useAdminReviews, useDeleteReview } from "../../hooks/useAdminReviews";
import StarRating from "../../../Routes/Marketplace/components/StarRating";
import PageHeader from "../../components/PageHeader";
import DataTable from "../../components/DataTable";
import EmptyState from "../../components/EmptyState";
import ConfirmModal from "../../components/ConfirmModal";
import { useState } from "react";

const AdminReviewsPage = () => {
  const { data, isLoading, isError } = useAdminReviews();
  const deleteReview = useDeleteReview();
  const [deleteId, setDeleteId] = useState(null);

  const reviews = data?.reviews || [];

  const columns = [
    { key: "product", label: "Product", render: (r) => r.product?.name || "—" },
    {
      key: "customer",
      label: "Customer",
      render: (r) => `${r.user?.first_name || ""} ${r.user?.last_name || ""}`.trim() || r.user?.email,
    },
    { key: "rating", label: "Rating", render: (r) => <StarRating rating={r.rating} showCount={false} size="sm" /> },
    { key: "comment", label: "Comment", render: (r) => r.comment || "—" },
    {
      key: "actions",
      label: "",
      render: (r) => (
        <button type="button" className="dashboard-btn dashboard-btn--danger" onClick={() => setDeleteId(r._id)}>
          Remove
        </button>
      ),
    },
  ];

  const confirmDelete = () => {
    deleteReview.mutate(deleteId, {
      onSuccess: () => {
        toast.success("Review removed");
        setDeleteId(null);
      },
      onError: () => toast.error("Could not remove review"),
    });
  };

  return (
    <>
      <PageHeader title="Reviews" subtitle="Moderate customer reviews" icon={FiStar} />
      {isError && <p style={{ color: "var(--dash-danger)" }}>Failed to load reviews.</p>}
      {!isLoading && reviews.length === 0 && !isError && (
        <EmptyState icon={FiStar} title="No reviews" message="Customer reviews will appear here." />
      )}
      <DataTable columns={columns} rows={reviews.map((r) => ({ ...r, _key: r._id }))} loading={isLoading} />
      <ConfirmModal
        open={!!deleteId}
        title="Remove review"
        message="This review will be permanently deleted."
        danger
        confirmLabel="Remove"
        loading={deleteReview.isLoading}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteId(null)}
      />
    </>
  );
};

export default AdminReviewsPage;
